module.exports = __webpack_public_path__ + "img/profile-pic-christmas-night.c0a8420a.jpg";